export function activityCodesDisplayText(availableCodes: any[], organizationCodes: string | any[]): string {
  let result: string = '';
  if (organizationCodes && availableCodes) {
    const names: string[] = [];
    availableCodes.forEach((code) => {
      if (organizationCodes.indexOf(code.code) !== -1) {
        if (code.codes) {
          const r = activityCodesDisplayText(code.codes, organizationCodes);
          if (r && r !== '') {
            names.push(r);
          } else {
            names.push(code.custom || code.name);
          }
        } else {
          names.push(code.custom || code.name);
        }
      }
    });
    result = names.join(', ');
  }
  return result;
}
